import Actions             from 'Redux/Actions';
import { SalesRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from, EMPTY }     from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findMauDauWauEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findMauDauWauRequest.type),
    mergeMap(action => {
      return from(
        SalesRepository.findMauDauWau()
          .then(({ mau, dau, wau }) => Actions.findMauDauWauSuccess({ mau, dau, wau }))
          .catch(error => Actions.findMauDauWauFailure({ error })),
      );
    }),
  );
};
